/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "eu-west-1",
    "aws_appsync_graphqlEndpoint": "https://yznshv3venaa7i263so6zam7ea.appsync-api.eu-west-1.amazonaws.com/graphql",
    "aws_appsync_region": "eu-west-1",
    "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS",
    "aws_cognito_identity_pool_id": "eu-west-1:b417f8bc-ae63-4c42-a4f3-7110c81c976e",
    "aws_cognito_region": "eu-west-1",
    "aws_user_pools_id": "eu-west-1_KGdvUQE9b",
    "aws_user_pools_web_client_id": "1314poogo5ofnaqh66p6dhppsi",
    "oauth": {},
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_content_delivery_bucket": "canvas-20200513162425-hostingbucket-uppsala",
    "aws_content_delivery_bucket_region": "eu-west-1",
    "aws_content_delivery_url": "https://d3w428frpxpbr8.cloudfront.net",
    "aws_user_files_s3_bucket": "canvas55bddcd8e288450bbecbaa68d412868f174427-uppsala",
    "aws_user_files_s3_bucket_region": "eu-west-1"
};


export default awsmobile;
